import React, { useState, useEffect } from 'react';
import LoadingButton from './LoadingButton';
import CalculationProgress from './CalculationProgress';
// Reutiliza los estilos de SupplyMapSection para garantizar consistencia visual
// (mismo espaciado, tipografía y estilo de botón) — AC IT-3197.
import './SupplyMapSection.css';
import { useTokenOps } from '../../../components/TokenContext';
import { hostname } from '../../../providers/api';

// Circularity uses the same isolated run monitoring as LCA.
const CalculationSection = ({
  record,
  runCircularity,
  downloadCircularity,
  loadingCalculation,
  loadingDownload,
  isCalculateable,
  calculationStatus,
  downloadStatus,
  otherCalculationBusy,
}) => {
  const tokenOps = useTokenOps();
  const hasCompletedRun = calculationStatus?.label === 'Completed';
  const [lastCalculationDate, setLastCalculationDate] = useState(null);
  const [loadingDate, setLoadingDate] = useState(false);

  // Fecha del último cálculo de circularidad. El backend expone un endpoint
  // específico (IT-3119): GET /circularity-calculation/last-calculation/:id → devuelve
  // { lastCalculation: { runTimestamp } } o 404 si no hay cálculo aún.
  useEffect(() => {
    if (record?.id) {
      setLoadingDate(true);
      fetch(
        `${hostname}/circularity-calculation/last-calculation/${record.id}`,
        {
          headers: { authorization: 'Bearer ' + tokenOps.account?.accessToken },
        }
      )
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
          if (
            data &&
            data.lastCalculation &&
            data.lastCalculation.runTimestamp
          ) {
            setLastCalculationDate(data.lastCalculation.runTimestamp);
          }
        })
        .catch((error) =>
          console.log(
            'Error fetching last circularity calculation date:',
            error
          )
        )
        .finally(() => setLoadingDate(false));
    }
  }, [record?.id, tokenOps.account?.accessToken, hasCompletedRun]);

  return (
    <>
      <div className="supply-map-section__divider"></div>

      <div className="supply-map-section">
        <h3 className="supply-map-section__title">Circularity</h3>
        <div className="supply-map-section__content">
          <div className="supply-map-section__field">
            <strong className="supply-map-section__label">
              Last calculation
            </strong>
            <div className="supply-map-section__value">
              {loadingDate
                ? 'Loading...'
                : lastCalculationDate
                ? new Date(lastCalculationDate).toLocaleDateString('es-ES')
                : 'N/A'}
            </div>
          </div>
          <div>
            {!loadingDownload && (
              <LoadingButton
                color="primary"
                onClick={() => downloadCircularity(record)}
                disabled={loadingCalculation || otherCalculationBusy}
              >
                Download
              </LoadingButton>
            )}
            <CalculationProgress
              status={
                downloadStatus ||
                (loadingDownload
                  ? { label: 'Requesting export', percent: null }
                  : null)
              }
            />
          </div>
          <div>
            {!loadingCalculation && (
              <LoadingButton
                color="primary"
                variant="contained"
                onClick={runCircularity}
                disabled={
                  !isCalculateable || loadingDownload || otherCalculationBusy
                }
              >
                Run Circularity
              </LoadingButton>
            )}
            <CalculationProgress
              status={
                calculationStatus ||
                (loadingCalculation
                  ? { label: 'Submitting request', percent: null }
                  : null)
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CalculationSection;
